import React, { PureComponent } from 'react'
import { Select } from '@driftt/tide-core-legacy'
import { clone, isNil } from 'ramda'

class SelectFilter extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      selected: props.activeFilter.value,
      creatable: props.creatable,
    }
  }

  componentDidMount() {
    this.hydrateOptions()
  }

  componentDidUpdate(prevProps) {
    if(this.props.options !== prevProps.options) {
      this.hydrateOptions();
    }
  }

  hydrateOptions = () => {
    const { activeFilter } = this.props

    let options = this.props.options
    const optionValues = options.map(option => option.value)

    // If the value is custom and doesn't exist in the list upon instantiation, make it
    if (!!activeFilter && activeFilter.value !== '' && !optionValues.find(value => value === activeFilter.value)){
      options = [...options, { label: activeFilter.value, value: activeFilter.value }]
    }

    this.setState({ options })
  }

  updateValue = ({ value }) => {
    const {onUpdateCondition, activeFilter} = this.props

    const newFilter = clone(activeFilter)

    newFilter.value = [value]

    this.setState({
      selected: value
    })

    onUpdateCondition(newFilter)
  }

  onNewOptionClick = (option) => {
    const updatedOptions = [...this.state.options, option]

    this.setState({
      options: updatedOptions,
      selected: option
    })

    this.updateValue(option)
  }

  render() {
    const { selected, creatable, options } = this.state

    const selectOptions = {
      options: options,
      creatable: !isNil(creatable) ? creatable : false,
      onChange: this.updateValue,
      clearable: false,
      placeholder: !isNil(creatable) ? 'Type to create custom value' : 'Select an option...',
      multi: false,
      autoFocus: true,
      value: selected !== '' ? selected : null 
    }

    if (!!creatable) {
      selectOptions.onNewOptionClick = this.onNewOptionClick
    }

    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-options">
          <Select {...selectOptions}/>
        </div>
      </div>
    )
  }
}

export default SelectFilter


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/SelectFilter.js